import { render, staticRenderFns } from "./MarketingFormSendersList.vue?vue&type=template&id=d0a651d2&scoped=true"
import script from "./MarketingFormSendersList.vue?vue&type=script&lang=js"
export * from "./MarketingFormSendersList.vue?vue&type=script&lang=js"
import style0 from "./MarketingFormSendersList.vue?vue&type=style&index=0&id=d0a651d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a651d2",
  null
  
)

export default component.exports